module.exports = __webpack_public_path__ + "img/pay-welfare-banner.f4629649.png";